var map = {
	"./mileiq/index.jsx": 810,
	"./standard/index.jsx": 811
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1596;


//////////////////
// WEBPACK FOOTER
// ./src/client/screens/Sweepstakes/Terms ^\.\/.*\/index\.jsx$
// module id = 1596
// module chunks = 0